import { render, staticRenderFns } from "./yycf.vue?vue&type=template&id=1300910a&scoped=true&"
import script from "./yycf.vue?vue&type=script&lang=js&"
export * from "./yycf.vue?vue&type=script&lang=js&"
import style0 from "./yycf.vue?vue&type=style&index=0&id=1300910a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1300910a",
  null
  
)

export default component.exports